import type { Component } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'

export const isPinned = createCssCompNode('responsiveLayout', 'isPinned', {
	getDependencies: (component: Component, refs: FeatureRefs<'responsiveLayout'>) => refs.compLayouts(component),
	toViewItem: (__, breakpointsToLayouts) => {
		if (!breakpointsToLayouts) {
			return false
		}

		for (const breakpoint in breakpointsToLayouts) {
			const variantsToLayouts = breakpointsToLayouts[breakpoint]
			for (const variant in variantsToLayouts) {
				const layoutDataItems = variantsToLayouts[variant]
				for (const item of layoutDataItems) {
					if ('pinnedToContainer' in item && item.pinnedToContainer === true) {
						return true
					}
				}
			}
		}

		return false
	},
})
